import { CasesSection } from "@/features/cases/components/cases-section";
import { useActiveClient } from "@/layouts/client-layout";

export default function ClientCasesPage() {
  const { client } = useActiveClient();
  return (
    <div className="space-y-6">
      <CasesSection clientId={client.id} clientType={client.type === "Business" ? "B" : "I"} />
    </div>
  );
}
